import { Card3d } from '@components/ui/3d-card'
import React, { useState, useCallback, useEffect } from 'react'
import ImageWithFallback from '@components/ui/ImageWithFallback'
import { Heart, Code, ArrowRight } from 'lucide-react'
import { Button } from '@components/ui/button'
import Link from 'next/link'

const ModelItem = ({ model, isFavorite, toggleFavorite }) => {
  const { name, alias, eta, description, run_count, optimized_media } = model
  const [isSavedToFavorites, setIsSavedToFavorites] = useState(isFavorite)

  const handleToggleFavorite = useCallback(() => {
    setIsSavedToFavorites((prev) => !prev)
    console.log(model.id, !isSavedToFavorites, model.name)
    toggleFavorite(model.id, !isSavedToFavorites, model.name)
  }, [isSavedToFavorites, toggleFavorite, model.id, model.name])

  useEffect(() => {
    setIsSavedToFavorites(isFavorite)
  }, [isFavorite])

  return (
    <Link
      href={{
        pathname: '/model/[name]',
        query: { name: alias },
      }}
      passHref
    >
      <div className="flex flex-col hover:border hover:border-gray-200  hover:shadow-md cursor-pointer transform translate-y-4 transition-all duration-200 ai-card">
        <Card3d className="w-full " rotationIntensity={15} scale={1.05} perspective={1500}>
          <div className="relative overflow-hidden  ">
            {' '}
            {/* Blue background as fallback */}
            <div className="relative z-10 translate-z-40">
              <ImageWithFallback
                src={optimized_media?.image?.high}
                alt={name}
                width={300}
                height={200}
                className="w-full aspect-video object-cover"
                priority={optimized_media?.image?.high !== '/assets/agents-dummy/placeholder.svg'}
                loading={optimized_media?.image?.high === '/assets/agents-dummy/placeholder.svg' ? 'lazy' : 'eager'}
              />
            </div>
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-opacity duration-300" />
            <button
              onClick={handleToggleFavorite}
              className="absolute top-2 right-2 p-1 bg-black/50 text-white hover:scale-110 transition-transform duration-300 z-20 translate-z-60"
              aria-label={isSavedToFavorites ? 'Remove from favorites' : 'Add to favorites'}
            >
              <Heart className={`h-5 w-5 ${isSavedToFavorites ? 'fill-current' : ''}`} />
            </button>
            <div className="absolute bottom-2 left-2 flex items-center gap-1 bg-black/50 text-white text-xs px-2 py-1 z-20 translate-z-60">
              <span>{run_count}</span>
            </div>
            <div className="absolute bottom-2 right-2 bg-black/50 text-white text-xs px-2 py-1 z-20 translate-z-60">
              {eta}
            </div>
          </div>
        </Card3d>

        <div className="mt-3 space-y-3 px-2 py-3">
          <div>
            <h3 className="font-medium">{name}</h3>
            <p className="text-gray-500 text-sm mt-1 line-clamp-2">{description}</p>
          </div>
          <div className="flex items-center justify-between">
            <Link
              href={{
                pathname: '/model/[name]',
                query: { name: alias },
              }}
              passHref
            >
              <Button
                variant="secondary"
                size="sm"
                className="bg-purple-600 rounded-sm text-white hover:bg-purple-700 text-xs px-3 py-2 h-auto shadow-sm hover:shadow-md transition-shadow"
              >
                Try <ArrowRight className="h-3 w-3" />
              </Button>
            </Link>
            <Link
              href={{
                pathname: '/model/[name]',
                query: { name: alias, api: 'python' },
              }}
              passHref
            >
              <Button
                variant="secondary"
                size="sm"
                className="text-purple-600 rounded-sm bg-purple-50 hover:bg-purple-100 text-xs px-3 py-2 h-auto shadow-sm hover:shadow-md flex items-center gap-1"
              >
                <Code className="h-3 w-3" /> API
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default React.memo(ModelItem)
